import { ChangeDetectionStrategy, Component, Input, OnInit, Renderer2 } from '@angular/core'

import { PlayerListenerComponentDirective } from '../../../../base-component/player-listener.component'
import { ITrack } from '../../../../Interface/track'
import { PlayerLogic } from '../../../../player/AngPlayer'
import { CartService } from '../../../../services/cart.service'
import { RoutingPathService } from '../../../../services/environment.service'
import { I18nService, LgType } from '../../../../services/prod/i18n.service'
import { TrackInCartService } from '../../../../services/track-in-cart.service'

@Component({
  selector: 'bmcore-track-item-header',
  templateUrl: './bmcore-track-item-header.component.html',
  styleUrls: ['./bmcore-track-item-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackItemHeaderComponent extends PlayerListenerComponentDirective<any> implements OnInit {
  @Input() beat: ITrack
  @Input() showBeatmakerName = false

  lg: LgType
  checkoutPage: string

  constructor(
    public trackInCartService: TrackInCartService,
    public player: PlayerLogic,
    protected cartService: CartService,
    private i18nService: I18nService,
    private renderer: Renderer2,
    private routingPathService: RoutingPathService
  ) {
    super(player, cartService)
    this.checkoutPage = this.routingPathService.getCheckoutUrl()
  }

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
  }

  checkIsTrackInCart(id: number): boolean {
    return this.trackInCartService.checkIsTrackInCart(id)
  }

  wantToAddBeat(event: MouseEvent, beatId: number) {
    event.stopPropagation()

    /* No parent scroll on modal scroll */
    this.renderer.addClass(document.body, 'modal-open')
    this.cartService.wantAddBeat(beatId)
  }
}
